import { defineMessage } from "react-intl";

export const requestedInvestigationTranslation = defineMessage({
  id: "investigationActivity.requested",
  defaultMessage: "Requested",
});
